import React, {useContext, useState} from "react"
import {useTranslation} from "next-i18next"
import Link from "next/link"
import Typography from "../reusable/Typography/Typography"
import {CaretRightFill} from "react-bootstrap-icons"
import DataContext from "../../context/DataContext"
import ComparisonItemTopPart from "./ComparisonItemTopPart"
import {findBikeAttributeByName} from "../../utility/Helper"
import ComparisonDefaultComponent from "./ComparisonDefaultComponent"
import priceFormatter from "../../utility/priceFormatter"
import {generateUUID} from "../../utility/UUID"
import useCache from "../../hooks/useCache"
import {useRouter} from "next/router"
import getMainCategory from "../filter/GetMainCategory"
import ComparisonAiAssistant from "./ComparisonAiAssistant"

const ComparisonPageContent = () => {
	const {t} = useTranslation()
	const router = useRouter()
	const {comparisonProducts, setComparisonProducts} = useContext(DataContext)
	const {data: checkedComparisonProducts, isLoading} = useCache(`/api/products/bikes/fetch-bikes-by-slugs/${comparisonProducts}?locale=${router?.locale || "de"}&multiple=true`)
	const lengthCheckedProducts = checkedComparisonProducts?.length
	const attributesList = []
	const excludedAttributes = ["hex_color", "FeaturedPosition", "video_url", "sizes"]

	const [scrollOffset, setScrollOffset] = useState(0)
	if (!isLoading && checkedComparisonProducts?.length && !attributesList.length) {
		checkedComparisonProducts.forEach(bike => {
			bike?.attributes?.forEach(attribute => {
				if (!attributesList.includes(attribute.name) && !excludedAttributes.includes(attribute.name)) {
					attributesList.push(attribute.name)
				}
			})
		})
	}

	const onRemoveItem = slug => {
		setComparisonProducts(comparisonProducts.filter(item => item !== slug))
	}

	const onScroll = e => {
		setScrollOffset(e.target.scrollLeft >= 0 ? e.target.scrollLeft : 0)
	}

	return (!isLoading && comparisonProducts && comparisonProducts?.length ?
		<div className="container">
			<div className={"mt-3 pt-0 mb-2"}>
				<Link href={"/"}>
					<Typography variant="bodySm"
						semanticTag="span"
						className={"pointer text-dark"}>{t("Home")}</Typography>
				</Link>
				<CaretRightFill className={"ms-2 me-2 text-dark"}
					size={10}/>
				<Typography variant="bodySmBold"
					semanticTag="span"
					className={"text-dark"}>{t("compare-e-bikes")}</Typography>
			</div>
			<Typography className="mt-4 mb-4 my-lg-5 text-uppercase"
				variant="heading1">{t("compare-e-bikes")}</Typography>

			<div className="overflow-scroll position-relative scrollbar-hide"
				onScroll={onScroll}>
				<div className={"position-relative"}>
					<div>
						{!isLoading && checkedComparisonProducts?.length > 0 && <> <div className="d-flex">
							{!isLoading && checkedComparisonProducts.map((bike, index) => <ComparisonItemTopPart key={generateUUID()}
								index={index}
								bike={bike}
								onRemoveItem={onRemoveItem}
								lengthCheckedProducts={lengthCheckedProducts}/>)}
						</div>
						{lengthCheckedProducts <= 3 && <div className="d-none d-md-block pe-3 pe-lg-5"><hr/></div>}
						{lengthCheckedProducts <= 2 && <hr className="d-md-none"/>}
						</>}
					</div>
					<ComparisonAiAssistant
						comparisonProducts={comparisonProducts} />
					{/* {!isLoading && checkedComparisonProducts?.length > 0 && <div>
						<div className="mb-3 position-relative" style={{minHeight: 10}}>
							<Typography className="d-block position-absolute top-0 text-nowrap" variant="bodyLgBold" style={{
								left: scrollOffset
							}}>
								{t("Farbe")}
							</Typography>
						</div>
						<div className="d-flex">
							{checkedComparisonProducts.map((bike, index) => <ComparisonColorItem lengthCheckedProducts={lengthCheckedProducts} index={index} key={generateUUID()} bike={bike}/>)}
						</div>
						{lengthCheckedProducts <= 3 && <div className="d-none d-md-block pe-3 pe-lg-5"><hr/></div>}
						{lengthCheckedProducts <= 2 && <hr className="d-md-none" />}
					</div>} */}
					{!isLoading && checkedComparisonProducts?.length > 0 && <div>
						<div className="mb-3 position-relative"
							style={{minHeight: 10}}>
							<Typography className="d-block position-absolute top-0 text-nowrap"
								variant="bodyLgBold"
								style={{
									left: scrollOffset
								}}>
								{t("kategorie")}
							</Typography>
						</div>
						<div className="d-flex">
							{checkedComparisonProducts.map((bike, index) => {
								return (
									<div className="col-5 col-lg-4 d-flex flex-column justify-content-between"
										key={generateUUID()}>
										<div className="pe-3">
											<Typography key={generateUUID()}
												variant="bodyLg"
												semanticTag="p">{getMainCategory(bike?.categories)?.name}</Typography>
										</div>
										{lengthCheckedProducts > 3 && <div className={`d-none d-md-block ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
											<hr/>
										</div>}
										{lengthCheckedProducts > 2 && <div className={`d-md-none ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
											<hr/>
										</div>}
									</div>
								)
							})}
						</div>
						{lengthCheckedProducts <= 3 && <div className="d-none d-md-block pe-3 pe-lg-5"><hr/></div>}
						{lengthCheckedProducts <= 2 && <hr className="d-md-none"/>}
					</div>}
					{!isLoading && checkedComparisonProducts?.length > 0 && <div>
						<div className="mb-3 position-relative"
							style={{minHeight: 10}}>
							<Typography className="d-block position-absolute top-0 text-nowrap"
								variant="bodyLgBold"
								style={{
									left: scrollOffset
								}}>
								{t("Preis")}
							</Typography>
						</div>
						<div className="d-flex">
							{checkedComparisonProducts.map((bike, index) => {
								return (
									<div className="col-5 col-lg-4 d-flex flex-column justify-content-between"
										key={generateUUID()}>
										<div className="pe-3">
											<Typography key={generateUUID()}
												variant="bodyLg"
												semanticTag="p">{t(`CHF ${priceFormatter(parseFloat(bike.uvpPrice))}`)}</Typography>
										</div>
										{lengthCheckedProducts > 3 && <div className={`d-none d-md-block ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
											<hr/>
										</div>}
										{lengthCheckedProducts > 2 && <div className={`d-md-none ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
											<hr/>
										</div>}
									</div>
								)
							})}
						</div>
						{lengthCheckedProducts <= 3 && <div className="d-none d-md-block pe-3 pe-lg-5"><hr/></div>}
						{lengthCheckedProducts <= 2 && <hr className="d-md-none"/>}
					</div>}

					{attributesList.length > 0 && attributesList.map(attribute => {
						return (
							<div key={generateUUID()}>
								<div className="mb-3 position-relative"
									style={{minHeight: 10}}>
									<Typography variant="bodyLgBold"
										className={"d-block position-absolute top-0 text-nowrap"}
										style={{
											left: scrollOffset
										}}>
										{t(attribute)}
									</Typography>
								</div>

								<div className="d-flex">
									{checkedComparisonProducts.map((bike, index) => {
										const attributesForComparison = findBikeAttributeByName(bike, attribute, false, false)
										return (
											<div className="col-5 col-lg-4 d-flex flex-column justify-content-between"
												key={generateUUID()}>
												<div className="pe-3">
													{attributesForComparison?.map(item => <Typography key={generateUUID()}
														variant="bodyLg"
														semanticTag="p">{t(item)}</Typography>)}
												</div>
												{lengthCheckedProducts > 3 && <div className={`d-none d-md-block ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
													<hr/>
												</div>}
												{lengthCheckedProducts > 2 && <div className={`d-md-none ${lengthCheckedProducts === index + 1 && "pe-3 pe-lg-5"}`}>
													<hr/>
												</div>}
											</div>
										)
									})}
								</div>
								{lengthCheckedProducts <= 3 && <div className="d-none d-md-block pe-3 pe-lg-5"><hr/></div>}
								{lengthCheckedProducts <= 2 && <hr className="d-md-none"/>}
							</div>
						)
					})}
				</div>
			</div>
		</div> :
		<>
			<div className="container">
				<div className={"mt-2 pt-0 mb-2"}>
					<Link href={"/"}>
						<Typography variant="bodySm"
							semanticTag="span"
							className={"pointer text-dark"}>{t("Home")}</Typography>
					</Link>
					<CaretRightFill className={"ms-2 me-2 text-dark"}
						size={10}/>
					<Typography variant="bodySmBold"
						semanticTag="span"
						className={"text-dark"}>{t("compare-e-bikes")}</Typography>
				</div>
				<ComparisonDefaultComponent/>
			</div>
		</>
	)
}

export default ComparisonPageContent
